import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, Bell, Banknote, ShieldAlert, ShieldCheck, BadgePercent, ClipboardCheck, ClipboardX, Target, AlertTriangle, MessageSquare, CheckCheck, Receipt } from "lucide-react";

const ICON = { payout_paid: Banknote, deposit_deducted: ShieldAlert, deposit_refilled: ShieldCheck, approval: BadgePercent, draft_accepted: ClipboardCheck, draft_rejected: ClipboardX, target: Target, cheque_bounced: AlertTriangle, message: MessageSquare, invoice_paid: Receipt };
const TONE = { deposit_deducted: "text-destructive", cheque_bounced: "text-destructive", draft_rejected: "text-destructive", payout_paid: "text-primary", deposit_refilled: "text-primary", draft_accepted: "text-primary", invoice_paid: "text-primary" };

export default function AgentInbox() {
  const [data, setData] = useState(null);
  const load = () => api.get("/agent/notifications").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.post("/agent/notifications/read", {}); load(); window.dispatchEvent(new Event("inbox-changed")); };
  const readOne = async (n) => { if (n.read_at) return; await api.post("/agent/notifications/read", { ids: [n.id] }); load(); window.dispatchEvent(new Event("inbox-changed")); };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold tracking-tight flex items-center gap-2"><Bell className="w-5 h-5 text-primary" /> Inbox</h1>
        {data?.unread > 0 && <Button size="sm" variant="ghost" onClick={readAll} data-testid="inbox-read-all"><CheckCheck className="w-4 h-4 mr-1" /> Mark all read</Button>}
      </div>
      {!data ? <div className="flex justify-center py-16"><Loader2 className="w-5 h-5 animate-spin text-primary" /></div>
        : data.items.length === 0 ? <p className="text-sm text-muted-foreground">No notifications yet. Payouts, deposit changes, approvals and messages from the office appear here.</p>
          : data.items.map((n) => {
            const Icon = ICON[n.kind] || Bell;
            const inner = (
              <Card className={`p-3.5 flex gap-3 ${n.read_at ? "opacity-70" : "border-primary/40"}`} onClick={() => readOne(n)} data-testid={`inbox-item-${n.id}`}>
                <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${TONE[n.kind] || "text-muted-foreground"}`} />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2"><p className="text-sm font-medium truncate">{n.title}</p>{!n.read_at && <span className="w-2 h-2 rounded-full bg-primary shrink-0" />}</div>
                  {n.body && <p className="text-xs text-muted-foreground mt-0.5">{n.body}</p>}
                  <p className="text-[11px] text-muted-foreground mt-1">{n.created_at?.slice(0, 16).replace("T", " ")}{n.kind === "message" && n.by ? ` · from ${n.by}` : ""}</p>
                </div>
              </Card>
            );
            return n.link ? <Link key={n.id} to={n.link} className="block">{inner}</Link> : <div key={n.id}>{inner}</div>;
          })}
    </div>
  );
}
